export default __webpack_public_path__ + "static/media/x_square.0d4cd578.svg";